import React, {PropTypes} from 'react';
import { Field, reduxForm } from 'redux-form';
import { FormControl } from 'react-bootstrap';
import Checkmark from '../../core/components/Checkmark'
import FieldError from '../../core/components/FieldError'
import {required, minLength1, batchEmails} from './reducer'

const renderField = ({ input, label, type, meta: { touched, error, warning } }) =>
  <div>
    <label>{label}</label>
    <div>
    <FormControl {...input}
      value={input.value}
      componentClass="textarea"
      placeholder="example@mail.com, example2@mail.com"
    />
    {touched && ((error && <FieldError message={error}/>) || (warning && <FieldError message={warning}/>))}
    </div>
  </div>

const AddMemberForm = ({ pristine, buttonContent, handleSubmit, submitting, showCheckmark, ...state}) => {
  return (
    <div>
      <form className="add-client-form" onSubmit={handleSubmit}>
        <Field name="emails" type="text"
          component={renderField} label="Emails"
          validate={[ required, minLength1, batchEmails ]}
        />
        <button className="btn btn-main-green" type="submit" disabled={submitting}>
          {submitting ? "Adding..." : showCheckmark ? <Checkmark/> : "Add Members"}
        </button>
      </form>
    </div>
  )
}


AddMemberForm.propTypes = {};

export default reduxForm({
  form: 'AddMemberForm'
})(AddMemberForm);



// WEBPACK FOOTER //
// ./src/enterprise/members/AddMemberForm.js